import styled from "styled-components";
import BgImage from "../../assets/images//big-bg.png";

export const Section = styled.section`
  width: 50%;
  height: 100vh;
  @media only screen and (min-width: 1600px) {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
`;

export const ImageSection = styled.section`
  width: 45%;
  height: 100vh;
  @media only screen and (min-width: 1600px) {
    display: none;
  }
`;

export const LoginRoot = styled.div`
  display: flex;
  @media only screen and (min-width: 1600px) {
    background-image: url(${BgImage});
    background-size: cover;
    background-repeat: no-repeat;
  }
`;

export const MyLoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 80px;
  height: 100%;
  @media only screen and (min-width: 1600px) {
    margin-left: 0px;
    height: 80%;
    margin-right: 80px;
    background: white;
    padding: 32px;
    margin-top: 40px;
  }
`;

export const MyLabel = styled.label`
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #636c79;
`;

export const MyInput = styled.input`
  background: #f1f4fb;
  border-radius: 32px;
`;

export const MyButton = styled.button`
  background: #4d9fc4;
  border-radius: 32px;
  padding: 6px;
  width: 50%;
`;

export const MyText = styled.p`
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 44px;
  letter-spacing: -0.02em;
  color: #05162a;
  margin-bottom: 2.4em;
`;

export const LogoImg = styled.img`
  position: absolute;
  left: 10%;
  top: 20px;
  transform: scale(0.55);
`;

export const IconWrapper = styled.div`
  display: inline-block;
  height: 36px;
  width: 36px;
  cursor: pointer;
  z-index: 20;
  position: absolute;
  right: 15px;
  bottom: ${(props: { error: boolean }) => (props.error ? "28px" : "24px")};
`;

export const MyIcon = styled.img`
  height: 20px;
  width: 20px;
  vertical-align: middle;
`;

export const LoginBgPreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ErrorDiv = styled.div`
  margin: -20px 0 20px 0;
  maxwidth: 310px;
`;

export const ErrorText = styled.p`
  color: red;
  border-left: 4px solid red;
  padding: 10px;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
`;
